import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';
import onClickOutside from 'react-onclickoutside';

import styles from '../styles.js';
import buttonStyles from '../FilterGroupCollection/Button/styles';

import FilterGroupCollection from '../FilterGroupCollection';

class FilterButtonBar extends Component {
    static propTypes = {
        activeFilterGroupCollectionIndex: PropTypes.number.isRequired,
        filterGroupCollections: PropTypes.array.isRequired,
        getActiveFilters: PropTypes.number.isRequired,
        isAdmin: PropTypes.bool.isRequired,
        setActiveFilterGroupCollection: PropTypes.func.isRequired,
        toggleAdminMode: PropTypes.func.isRequired,
        updateFilterGroupCollection: PropTypes.func.isRequired
    }

    state = {
        adminToggleText: 'Normal',
        adminToggleValue: 0,
        showAdminToggle: false
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {
            activeFilterGroupCollectionIndex,
            filterGroupCollections
        } = this.props;
        if (JSON.stringify(filterGroupCollections) !== JSON.stringify(nextProps.filterGroupCollections)) {
            return true;
        }
        if (activeFilterGroupCollectionIndex !== nextProps.activeFilterGroupCollectionIndex) {
            return true;
        }
        if (nextState.showAdminToggle !== this.state.showAdminToggle || nextState.adminToggleText !== this.state.adminToggleText) {
            return true;
        }
        return false;
    }

    handleActiveFilterGroupCollection = (filterGroupCollectionIndex, shouldClose = false) => {
        const {
            activeFilterGroupCollectionIndex,
            setActiveFilterGroupCollection
        } = this.props;
        if (shouldClose || Number(activeFilterGroupCollectionIndex) === Number(filterGroupCollectionIndex)) {
            setActiveFilterGroupCollection(-1);
        } else {
            filterGroupCollectionIndex = filterGroupCollectionIndex || filterGroupCollectionIndex === 0 ? filterGroupCollectionIndex : -1;
            setActiveFilterGroupCollection(filterGroupCollectionIndex);
        }
    }

    handleClickOutside = () => {
        const { handleActiveFilterGroupCollection } = this;
        handleActiveFilterGroupCollection(-1, true);
    }

    handleToggleAdminToggle = () => {
        this.setState(prevState => ({
            showAdminToggle: !prevState.showAdminToggle
        }));
    }

    handleChangeAdminToggle = e => {
        e.persist();
        this.props.toggleAdminMode(e);
        const index = e.nativeEvent.target.selectedIndex;
        this.setState(prevState => ({
            adminToggleText: e.nativeEvent.target[index].text,
            adminToggleValue: e.nativeEvent.target[index].value,
            showAdminToggle: !prevState.showAdminToggle
        }));
    }

    renderFilterGroupCollection = (filterGroupCollection, index) => {
        const {
            handleActiveFilterGroupCollection
        } = this;
        const { getActiveFilters, updateFilterGroupCollection } = this.props;
        return (
            <FilterGroupCollection
                key={shortid.generate()}
                filterGroupCollectionIndex={index}
                filterGroupCollection={filterGroupCollection}
                getActiveFilters={getActiveFilters}
                handleActiveFilterGroupCollection={handleActiveFilterGroupCollection}
                updateFilterGroupCollection={updateFilterGroupCollection}
            />
        );
    }

    render() {
        const {
            renderFilterGroupCollection
        } = this;
        const { filterGroupCollections } = this.props;
        return (
            <div className={css(styles.container)}>
                <div
                    role="menubar"
                    className={css(styles.filterBar)}
                >
                    {filterGroupCollections.map(renderFilterGroupCollection)}
                    <div className={css(styles.adminToggleContainer)}>
                        {
                            this.props.isAdmin ?
                                <button
                                    role="menuitem"
                                    aria-haspopup="true"
                                    className={css(
                                        buttonStyles.menuItem,
                                        this.state.showAdminToggle &&
                                        buttonStyles.menuItemActive
                                    )}
                                    onClick={this.handleToggleAdminToggle}
                                >
                                    <div className={css(buttonStyles.label)}>
                                        <span>
                                            {this.state.adminToggleText}
                                        </span>
                                    </div>
                                    <span className={css(buttonStyles.chevron)}>
                                        <div
                                            className={css(
                                                this.state.showAdminToggle ?
                                                    buttonStyles.iconWrapperOpen : buttonStyles.iconWrapper
                                            )}
                                        >
                                            <svg
                                                className={css(buttonStyles.chevronSvg)}
                                                viewBox="0 0 18 18"
                                                role="presentation"
                                                aria-hidden="true"
                                                focusable="false"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                                                />
                                            </svg>
                                        </div>
                                    </span>
                                </button> : null
                        }
                        {
                            this.props.isAdmin && this.state.showAdminToggle ?
                                <div className={css(styles.adminToggle)}>
                                    <div className={css(styles.selectContainer)}>
                                        <select
                                            className={css(styles.select)}
                                            onChange={this.handleChangeAdminToggle}
                                            value={this.state.adminToggleValue}
                                        >
                                            <option value="0">
                                                Normal
                                            </option>
                                            <option value="1">
                                                Tagging
                                            </option>
                                        </select>
                                    </div>
                                </div> : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default onClickOutside(FilterButtonBar);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterButtonBar/FilterButtonBar.jsx